import Vue from 'vue';

//

/**
 * Be aware that this component talks to parent in hacky way (not by props-event as recommended)
 * but the component calls $parent's methods directly. Vue does not recommend this pattern
 * but we use is it here as an exception to simplify usage od accordion.
 * 
 * @deprecated Use SdsAccordionItem instead
 */
var script = Vue.component('AccordionItem', {
    name: 'AccordionItem',
    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isPreOpened: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.isPreOpened || this.$parent.active && this.$parent.active.index === this.uuid,
        };
    },
    beforeCreate() {
        this.uuid = this.$parent.getUuid();
    },
    updated() {
        if (this.isOpen) {
            this.$parent.setActiveHeight(this.$refs.contentBox.clientHeight);
        }
    },
    computed: {
        iconClass() {
            const iconClassNames = ['toggle-icon'];
            if (this.isOpen) {
                iconClassNames.push(' icon-chevron_up');
            } else {
                iconClassNames.push(' icon-chevron_down');
            }
            return iconClassNames;
        },
    },
    watch: {
        '$parent.active': function (newActive) {
            this.isOpen = newActive && newActive.index === this.uuid;
        },
    },
    methods: {
        onClick() {
            if (this.isDisabled) {
                return;
            }
            this.$parent.setActive({
                index: this.uuid,
                height: 0,
            });
        },
    },
});

export default script;
